import { LayoutLogoListCms } from '@cerifi/ui/cms/layouts/layout-logo-list.cms'

import { LayoutLogoList as LayoutLogoListModel } from '../../__generated/graphql.types'

const LayoutLogoList = ({ content }: { content: LayoutLogoListModel }) => {
  return (
    <LayoutLogoListCms
      isH1={(content as any).IS_H1}
      id={content.sys.id}
      interval={content.carouselSpeed || undefined}
      title={content.title}
      layoutOption={content.layoutOption as any}
      collection={(content.contentCollection?.items as any) || []}
      button={content.button}
      paddingOnTop={!!content.paddingOnTop}
      paddingOnBottom={!!content.paddingOnBottom}
    />
  )
}

export default LayoutLogoList
